
import marked from '@/mixins/marked'
export default {
  props: {
    item: Object
  },

  mixins: [marked],
};
